import { $KnowAndShowLevel, $ModuleArea, ModuleArea } from '@suntex.fim/enums';

import { NodeModel } from '../../../types';
import { buildKSLevelNode } from '../../utils/buildKSLevelNode';

const moduleAreaDesc = $ModuleArea.describe(ModuleArea.KnowAndShow);

export const ksNode: NodeModel = {
  tag: moduleAreaDesc.slug,
  info: {
    title: moduleAreaDesc.label,
    summary: 'First in Reading®',
  },
  label: {
    aria: moduleAreaDesc.label,
    class: 'MainLabel',
    frame: 6,
  },
  color: moduleAreaDesc.color,
  layout: 'levels',
  children: $KnowAndShowLevel
    .describeAll()
    .map(({ value: level }) => buildKSLevelNode({ level })),
};
